import { createSlice } from '@reduxjs/toolkit';

import { RootState } from 'store/store';

import { IUser, IUser as User } from 'models/User';
import { DEMO_EMAIL } from 'appConstants';
import { isAuthenticated, login, logout } from 'services/auth.service';

export interface IAuthentication {
    loading: boolean;
    user?: User | null;
}

const demoUser: IUser = {
    firstName: 'Demo',
    lastName: 'Demo',
    email: DEMO_EMAIL,
    token: '',
    roles: ['OEM', 'employee']
} 

const name = 'authentication';

const initialState: IAuthentication = { loading: false, user: null };

export const authenticationSlice = createSlice({
    name,
    initialState,
    reducers: {
        setDemoUser: (state) => {
            state.user = demoUser
        },
        resetUser: (state) => {
            state.user = null;
            state.loading = false;
        },
        setLoading: (state, action) => {
            state.loading = !action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(isAuthenticated.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
            })
            .addCase(isAuthenticated.pending, (state) => {
                state.loading = true;
            })
            .addCase(isAuthenticated.rejected, (state) => {
                state.loading = false;
            })
            .addCase(login.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
            })
            .addCase(login.pending, (state) => {
                state.loading = true;
            })
            .addCase(login.rejected, (state) => {
                state.loading = false;
            })
            .addCase(logout.fulfilled, (state) => {
                state.user = null;
                state.loading = false;
            })
            .addCase(logout.pending, (state) => {
                state.loading = true;
            })
            .addCase(logout.rejected, (state) => {
                state.loading = false;
            })
    }
});

export const { setDemoUser, resetUser, setLoading } = authenticationSlice.actions;
export const selectAuthentication = (state: RootState) => state.authentication;
export const authenticationReducer = authenticationSlice.reducer;